import { FC } from 'react';

interface LegalCertificationProps {
  isIdCase?: boolean;
}
export const LegalCertification: FC<LegalCertificationProps> = (props) => {
  return (
    <div
      style={{
        border: '1px solid'
      }}
      className="border p-4 min-h-[300px] max-h-[40vh] overflow-y-auto"
    >
      <div>
        {props?.isIdCase ? (
          <>
            <h3>Account Establishment Attestation</h3>
            <p>
              I hereby certify that the information that I have provided to establish a Credential Verification for Health Professionals (CVHP) Account was provided solely by
              me and is true and correct to the best of my knowledge. I understand that the decision as to whether I qualify for a CVHP Account or to receive any ECFMG
              services rests solely and exclusively with ECFMG and that ECFMG's decision-making authority is ongoing. I certify I understand that, among other things, ECFMG
              may report actual or suspected activities of irregular behavior to the entity to which I am applying; to U.S. and international medical registration and
              licensing authorities; educational institutions; places of employment; and/or any other organization or individual who, in the sole judgment of ECFMG has a
              legitimate interest in such information and/or where such disclosure is necessary for ECFMG to provide the requested services, and such reporting could result in
              actions to my professional practice, among other things. I understand that irregular behavior includes my submission of falsified documents and/or information to
              ECFMG as part of the services provided to me and/or other activities on my part that would or could subvert ECFMG's processes and procedures.
            </p>
            <p>
              By checking this box, I certify that I have read, understood, and agree to the terms of the Credential Verification for Health Professionals (CVHP) Account
              Establishment Attestation as described above and agree to be legally bound by them.
            </p>
          </>
        ) : (
          ''
        )}
        <h3>Release of Legal Claims, Indemnification, and Hold Harmless Statement </h3>
        <p>
          I acknowledge that ECFMG makes no warranties, express or implied, as to any matter whatsoever, and any and all warranties are expressly disclaimed and excluded. I
          further acknowledge Intealth, its Board of Trustees, committees, officers, divisions ECFMG and FAIMER, employees, contractors, and agents (collectively, “Intealth”)
          shall not be liable for any losses, liabilities, or damages whatsoever, including, without limitation, any direct, indirect, consequential, incidental or special
          damages, arising from use of or reliance on ECFMG's services.
        </p>
        <p>
          I hereby release Intealth of and from any and all liabilities, complaints, claims, lawsuits, damages, demands, losses, and expenses arising out of or in connection
          with any action or omission by Intealth in connection with any request and/or activities related to services that ECFMG provides to me; any investigation of my
          credentials, documents and actions; any investigation or finding of irregular behavior; and/or any failure or refusal to issue a report for CVHP services
          (collectively, “Claims”) whatsoever I may have, now and in the future, in consideration for the receipt of any services ECFMG provides to me. I also hereby agree to
          indemnify and hold harmless Intealth with respect to any and all Claims brought by myself or a third party (including Intealth's reasonable attorneys' fees incurred
          defending a Claim).
        </p>
        <p>
          By checking this box, I certify that I have read, understood, and agree to the terms of the Release of Legal Claims, Indemnification, and Hold Harmless Statement as
          described above and agree to be legally bound by them.
        </p>
        <h3>Release of Information Authorization </h3>
        <p>
          I hereby request and authorize every person, medical regulatory authority, university, hospital, government agency, or other entity to release any documents and
          information to ECFMG bearing on the content of my application or other request related to services that I have asked ECFMG to provide to me, including, but not
          limited to: records, diplomas, transcripts, licenses/registrations, and other documents concerning my identity, citizenship or immigration status, educational,
          academic or professional history and status, or enrollment.
        </p>
        <p>
          I hereby authorize ECFMG to transmit any documents or information in its possession, or that may otherwise become available to ECFMG, bearing on the content of my
          application or other request related to services I have requested ECFMG provide to me, including, but not limited to: records; diplomas; transcripts;
          licenses/registrations; and other documents concerning my identity, citizenship or immigration status, educational, academic or professional history and status, or
          enrollment; and documentation of irregular behavior on my part to U.S. state and international medical licensing authorities; educational institutions, places of
          employment; and/or any other organization or individual who, in the sole judgment of ECFMG has a legitimate interest in such information and/or where such disclosure
          is necessary for ECFMG to provide the requested services. I understand that irregular behavior includes my submission of falsified documents and/or information to
          ECFMG as part of the services provided to me and/or other activities on my part that would or could subvert ECFMG’s processes and procedures.
        </p>
        <p>
          I also extend absolute immunity to, and release, other agencies, universities, institutions, hospitals and clinics, and registration and licensing authorities
          providing information, their employees, contractors, representatives, trustees, directors, and officers, and any third parties and organizations for their acts,
          communications, reports, records, diplomas, transcripts, statements, documents, recommendations, or disclosures involving me, made in good faith and without malice,
          requested by ECFMG.
        </p>
        <p>
          By checking this box, I certify that I have read, understood, and agree to the terms of the Release of Information Authorization as described above and agree to be
          legally bound by them.
        </p>
        <h3>Acknowledgement of Terms and Conditions and Privacy Notice</h3>
        <p>By checking this box, I confirm that I have read, understood, and agree to the Intealth Terms and Conditions and Intealth Privacy Notice. </p>
      </div>
    </div>
  );
};
